import { render, staticRenderFns } from "./VListItem.vue?vue&type=template&id=0491cd14&"
import script from "./VListItem.vue?vue&type=script&lang=js&"
export * from "./VListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports